import { getApps, initializeApp } from 'firebase/app';
import { child, get, getDatabase, ref, update } from 'firebase/database';
import { firebaseConfig } from './useFirebase';

if (!getApps().length) {
  initializeApp(firebaseConfig);
}

export const getFirebaseLiveData = () => {
  const dbRef = ref(getDatabase());

  const getValues = async (path, id) => {
    const fetchedData = await get(child(dbRef, `${path}${id}`))
      .then((snapshot) => {
        if (snapshot.exists()) {
          return snapshot.val();
        }
      })
      .catch((error) => {
        console.error(error);
      });
    return fetchedData;
  };

  const updateValuesInFireBaseDB = (updates) => {
    if (updates) {
      update(dbRef, updates).then(() => {
        getValues();
      });
    }
  };
  return { getValues, updateValuesInFireBaseDB };
};
